/**
 * Public routes that support optional language prefix /:lang.
 * Used by App.js for /:lang nested routes and by LanguageSwitcher for navigation.
 * Paths are without leading slash for nested route path; with leading slash for pathname checks.
 */
export const publicRoutePaths = [
  "",
  "features",
  "pricing",
  "about",
  "contact",
  "integrations",
  "changelog",
  "blog",
  "careers",
  "documentation",
  "help-center",
  "api-reference",
  "status",
  "privacy",
  "terms",
  "security",
  "login",
  "signup",
];

/** Pathname (with leading slash, no trailing) -> true if public. Root is "/". Includes /blog/:idOrSlug. */
export function isPublicPathname(pathname) {
  if (!pathname || pathname === "/") return true;
  const normalized = pathname.replace(/\/$/, "");
  const withoutLang = normalized.replace(/^\/[a-z]{2}(-[a-z0-9]+)?(\/|$)/i, (_, __, rest) => rest || "/");
  const segment = withoutLang === "/" ? "" : withoutLang.slice(1);
  if (publicRoutePaths.includes(segment)) return true;
  if (segment.startsWith("blog/")) return true;
  return false;
}

/**
 * Strip language prefix from pathname. Returns path suitable for default-language URL.
 * e.g. /es/features -> /features, /fr -> /. Only strips if segment is followed by / or end.
 */
export function getPathWithoutLangPrefix(pathname) {
  if (!pathname || pathname === "/") return "/";
  const normalized = pathname.replace(/\/$/, "") || "/";
  const without = normalized.replace(/^\/[a-z]{2}(-[a-z0-9]+)?(\/|$)/i, (_m, _g1, _g2, rest) => (rest === "/" ? "/" : ""));
  return without || "/";
}
